import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import DocumentViewer from './components/documentViewer';

ReactDOM.render(<DocumentViewer />, document.getElementById('root'));
